'use client';
import NextLink from 'next/link';
import { AnchorHTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string;
    children: ReactNode;
    external?: boolean;
    className?: string;
    ariaLabel?: string;
}

const Link = ({
    href,
    children,
    external = false,
    className = '',
    ariaLabel,
    ...props
}: LinkProps) => {
    const baseClasses = 'inline-flex items-center transition-colors duration-200 focus:outline-none'

    if (external) {
        return (
            <a
                href={href}
                className={twMerge(baseClasses, className)}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={ariaLabel}
                {...props}
            >
                {children}
            </a>
        )
    }

    return (
        <NextLink
            href={href}
            className={twMerge(baseClasses, className)}
            aria-label={ariaLabel}
            {...props}
        >
            {children}
        </NextLink>
    )
}

export default Link